<mwp-card-content-header contentTitleMwp="Report History" />
<div class="content-container">
    <div class="title">
        <mwp-text-translate text="Reports" jsonKey="reports" />
    </div>
    <div class="content">
        <mwp-report-history-table [reports]="reports" [deleteEnabled]="true" (emitDelete)="deleteReport($event)" />
    </div>
</div>
